class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState) {
  this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
  this.productId = parsedState.id;
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  });

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      // Vuelve a enlazar la validación del selector "Tipo de Documento" para asegurar que esté activo luego de que se actualiza el contenido del drawer
      this.attachDocumentTypeValidation();

      // Inicia el observador que detecta cambios en el contenido del drawer, como cuando se elimina un producto, se modifica la cantidad, etc.
      this.observeDrawerChanges(); // ahora observamos cambios reales cantidad y eliminacion de X productos/producto
    });
  });
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  attachDocumentTypeValidation() {
    const select = document.getElementById('document_type_drawer'); // Obtiene el <select> del tipo de documento
    const checkoutButton = document.querySelector('.cart__ctas #CartDrawer-Checkout'); // Botón de checkout

    // Verifica si existen el <select> y el botón de pago. Si no existen, termina la función
    if (!select || !checkoutButton) {
      //console.warn('[Drawer] No se encontró select o botón de checkout.');
      return; // Si alguno no existe, no hace nada
    }
    
    select.selectedIndex = 0; // Reinicia selección al abrir el drawer

    // Función que valida y guarda el valor seleccionado del tipo de documento
    const validateAndSave = () => {
      const value = select.value; // Obtiene el valor seleccionado (Boleta o Factura)
      const isValid = value === 'Boleta' || value === 'Factura'; // Valida selección
      
      // Activa o desactiva botón según validez
      checkoutButton.disabled = !isValid;
      checkoutButton.classList.toggle('button--disabled', !isValid);
      checkoutButton.style.opacity = isValid ? '1' : '0.5';
      checkoutButton.style.pointerEvents = isValid ? 'auto' : 'none';

      // Si es válido, guarda el atributo "Tipo de Documento" en el carrito
      if (isValid) {
        fetch('/cart/update.js', {
          method: 'POST', // Método para actualizar atributos
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              "Tipo de Documento": value // Guarda el valor seleccionado como atributo del carrito
            }
          })
        })
        .then(res => {
          // Si la respuesta no es OK, lanza error
          if (!res.ok) throw new Error('Error al guardar el atributo');
          //console.log('[Drawer] Atributo guardado con éxito:', value);
        })
        .catch(err => {
          // Captura errores en la petición y los muestra en consola
          console.error('[Drawer] Error al guardar Tipo de Documento:', err);
        });
      }
    };

    // Asegura que no se duplique el evento
    select.removeEventListener('change', validateAndSave);
    select.addEventListener('change', validateAndSave);

    // Valida al cargar el drawer
    validateAndSave();
  }

  observeDrawerChanges() {
    // Selecciona el contenedor principal del drawer (carrito lateral)
    const drawerInner = this.querySelector('.drawer__inner');

    // Si no existe el contenedor, no continúa
    if (!drawerInner) return;

    // Crea un observador para detectar cambios en el contenido del drawer (DOM)
    const observer = new MutationObserver(() => {
      //console.log('[Drawer] Cambio detectado. Reaplicando validación de tipo de documento.');
        
      // Cada vez que hay un cambio (eliminación de producto, cambio de cantidad, etc.),
      // vuelve a ejecutar la validación del selector de tipo de documento
      this.attachDocumentTypeValidation();
    });

    // Configura el observador para detectar:
    // - Cambios en los hijos directos
    // - Cambios profundos dentro del DOM del drawer
    observer.observe(drawerInner, {
      childList: true, // Cambios en los hijos directos (childList: true)
      subtree: true // Cambios profundos dentro del DOM del drawer (subtree: true)
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);